import { chatApiAxios } from "@/plugins";
import { UpdateChatMembersArgs } from "@/store/chats/types";
import { HttpRequestMethodEnum } from "@/types/api";
import { getCommonJsonHeaders } from "@/utils/api";

export const updateChatMembersBeAsync = async ({
  chatId,
  addMemberIds,
  removeMemberIds,
  accessToken,
}: UpdateChatMembersArgs) => {
  const res = await chatApiAxios("chat/" + chatId + "/members", {
    method: HttpRequestMethodEnum.PATCH,
    headers: getCommonJsonHeaders(accessToken),
    data: {
      addMemberIds,
      removeMemberIds,
    },
  });
  return res.data;
};
